module.exports = __webpack_public_path__ + "static/img/logo_ob.170dfe0.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/video/logo_ob.png
// module id = CS9f
// module chunks = 3